module.exports = __webpack_public_path__ + "img/will-trustees.f92f8cc9.svg";